// Resource definitions should match with the resources in OPA
export enum PermissionResources {
  // View Invoices And Credit Notes
  INVOICE_OVERVIEW = 'invoice-overview',
  INVOICE_DOCUMENTS = 'invoice-documents',
  // Request Deliveries And Ordering
  ORDER_NOW = 'order-now',
  MY_PRODUCTS_ORDERING = 'my-products-ordering',
  REQUEST_DELIVERY = 'request-delivery',
  SHOPPING_CART = 'shopping-cart',
  // View Prices
  ORDER_PRICE = 'order-price',
  PRODUCT_PRICE = 'product-price'
}
